import React from 'react';
import styled from 'styled-components';

// Styles
import {altInput} from '../styles/includes/forms'
import {baseButton} from '../styles/includes/buttons'


const StyledComponent = styled.div`
  text-align: center;
  max-width: 1024px;
  margin: auto;
  padding: 4rem;
  
  border:1px solid var(--color-rojo);
  border-top:none;
  margin:10px auto;
  position: relative;
  &:before{content:""; height: 1px; background-color:var(--color-rojo); width: 40%; position: absolute; top:0px; right:0px;}
  &:after{content:""; height: 1px; background-color:var(--color-rojo); width: 40%; position: absolute; top:0px; left:0px;}
  h1 {
    margin-bottom: 2rem;
  }
  form {
    margin-bottom: 2rem;
    max-width: 320px;
    margin: 0 auto;
  }
  input {
    margin-bottom: 2rem;
    ${altInput}
  }
  p {
    &:not(:last-child) {
      margin-bottom: .5rem;
    }
  }
  button {
    ${baseButton}
    width: 100%;
  }
  .successful-message {
    padding: 16px 32px;
    border: 1px solid var(--color-primary);
    color: var(--color-primary);
    text-align: center;
    border-radius: 4px;
    margin-bottom: 2rem;
  }  
`

const Component = ({children, ...rest}) => {
    return (
        <StyledComponent  {...rest}>
            {children}
        </StyledComponent>
    )
}

export default Component;
